// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import { LoginResponseSuccessFragmentDoc } from './fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../fragments/costumerConsultant.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AutologinDocument = `
    mutation autologin($authToken: String!, $isConsultant: Boolean!) {
  autologin(authToken: $authToken) {
    __typename
    ... on LoginResponseSuccess {
      ...loginResponseSuccess
    }
  }
}
    ${LoginResponseSuccessFragmentDoc}
${MeFragmentDoc}
${CostumerConsultantFragmentDoc}`;

export function useAutologinMutation() {
  return Urql.useMutation<SchemaTypes.AutologinMutation, SchemaTypes.AutologinMutationVariables>(AutologinDocument);
};